import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { Btn } from './../../../components/includes/ui';
import { InputTextField } from './../../../components/includes/ui/input';
import { SalesforceService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {};

  if (!values.policy) {
    errors.policy = VALIDATION.required;
  }

  if (!values.certificate) {
    errors.certificate = VALIDATION.required;
  }

  if (!values.endorsement) {
    errors.endorsement = VALIDATION.required;
  }

  if (!values.branch) {
    errors.branch = VALIDATION.required;
  }

  return errors

};

class PolicyFind extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      sending: false
    };
  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (values) => {

    SalesforceService.policy(values).then((response) => {

        console.log(response);

    }).catch((error) => {

      console.log(error);
      // @Dispatch alert error
      //this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Event
  ** @Description: Submit form
  */
  handleSubmitForm = (values) => {
    this._Find(values);
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>

        <ToolbarPrimary title="Polizas"/>
        <BreadcrumbItem to='/policy/find'>Polizas</BreadcrumbItem>

        <Content>
          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
              <Ttolbar title="Buscador de pólizas"/>

              <FormContent enabledActions>
                <Grid container spacing={24}>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Field
                        name="policy"
                        component={ InputTextField }
                        label="Poliza"
                        type="text"
                        required
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Field
                        name="certificate"
                        component={ InputTextField }
                        label="Certificado"
                        type="text"
                        required
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Field
                        name="endorsement"
                        component={ InputTextField }
                        label="Endoso"
                        type="text"
                        required
                    />
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Field
                        name="branch"
                        component={ InputTextField }
                        label="Ramo"
                        type="text"
                        required
                    />
                  </Grid>
                </Grid>
              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>

                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Buscar" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Buscar
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>
            </form>

          </Main>
        </Content>
      </Section>
    )
  }
}

PolicyFind = reduxForm({
  form: 'PolicyFind',
  validate,
  initialValues: {

  }
})(PolicyFind);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyFind);
